import "./HelpButton.css"
import {ReactComponent as InformationIcon} from "../../media/information.svg";

const HelpButton = ({setHelpScreenVisible, logHelpButtonClicked}) => {
    return ( <button onClick={() => {
        setHelpScreenVisible(true);
        logHelpButtonClicked();
        }} className="btn-help">            
    <InformationIcon className="info-icon"/>
    </button> );
}
 
export default HelpButton;